import { render, staticRenderFns } from "./importcustoms.vue?vue&type=template&id=46038fb8&scoped=true&"
import script from "./importcustoms.vue?vue&type=script&lang=js&"
export * from "./importcustoms.vue?vue&type=script&lang=js&"
import style0 from "./importcustoms.vue?vue&type=style&index=0&id=46038fb8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46038fb8",
  null
  
)

export default component.exports